import { render, staticRenderFns } from "./DynamicTableInput.vue?vue&type=template&id=763c1b34&scoped=true&"
import script from "./DynamicTableInput.vue?vue&type=script&lang=ts&"
export * from "./DynamicTableInput.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicTableInput.vue?vue&type=style&index=0&id=763c1b34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763c1b34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
